export class Millis {
  static fromSeconds(seconds: number) {
    return seconds * 1000;
  }

  static fromMinutes(minutes: number) {
    return minutes * 60 * 1000;
  }
}
